export default __webpack_public_path__ + "static/media/slide-cell.72778d9d.svg";